import { gql } from '@apollo/client';
import { GRAPHQL_FRAGMENTS } from 'client/data/constants/graphql-fragments';
import { CAR_TYPES } from 'site-modules/shared/constants/upper-funnel/car-types';

export const COMPLEX_TYPE_RANKINGS_QUERIES = {
  [CAR_TYPES.EXOTIC]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
        exotic_coupes: editorialVehicleRankings(
          edmundsTypeCategory: "Coupe"
          subsegment: "Exotic"
          market: "Exotic coupes"
        ) {
          ...editorialSegmentFieldsFull
        }
        exotic_sport_coupes: editorialVehicleRankings(
          edmundsTypeCategory: "Coupe"
          subsegment: "Sport"
          market: "Exotic coupes"
        ) {
          ...editorialSegmentFieldsFull
        }
        exotic_sedans: editorialVehicleRankings(edmundsTypeCategory: "Sedan", subsegment: "Exotic") {
          ...editorialSegmentFieldsFull
        }
        exotic_convertibles: editorialVehicleRankings(
          edmundsTypeCategory: "Convertible"
          subsegment: "Exotic"
          market: "Exotic convertibles"
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.ECONOMY]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
        subcompact_sedans: editorialVehicleRankings(
          edmundsTypeCategory: "Sedan"
          subsegment: "X-Small"
          market: "Sedans"
        ) {
          ...editorialSegmentFieldsFull
        }
        compact_sedans: editorialVehicleRankings(edmundsTypeCategory: "Sedan", subsegment: "Small", market: "Sedans") {
          ...editorialSegmentFieldsFull
        }
        subcompact_hatchbacks: editorialVehicleRankings(
          edmundsTypeCategory: "Hatchback"
          subsegment: "X-Small"
          market: ""
        ) {
          ...editorialSegmentFieldsFull
        }
        compact_hatchbacks: editorialVehicleRankings(
          edmundsTypeCategory: "Hatchback"
          subsegment: "Small"
          market: ""
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.SUBCOMPACT]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
        subcompact_sedans: editorialVehicleRankings(
          edmundsTypeCategory: "Sedan"
          subsegment: "X-Small"
          market: "Sedans"
        ) {
          ...editorialSegmentFieldsFull
        }
        subcompact_hatchbacks: editorialVehicleRankings(
          edmundsTypeCategory: "Hatchback"
          subsegment: "X-Small"
          market: ""
        ) {
          ...editorialSegmentFieldsFull
        }
        subcompact_luxury_crossovers: editorialVehicleRankings(
          edmundsTypeCategory: "SUV"
          subsegment: "X-Small"
          market: "Luxury SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        subcompact_crossovers: editorialVehicleRankings(
          edmundsTypeCategory: "SUV"
          subsegment: "X-Small"
          market: "SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.MIDSIZE]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
        midsize_sedans: editorialVehicleRankings(
          edmundsTypeCategory: "Sedan"
          subsegment: "Midsize"
          market: "Sedans"
        ) {
          ...editorialSegmentFieldsFull
        }
        midsize_luxury_sedans: editorialVehicleRankings(
          edmundsTypeCategory: "Sedan"
          subsegment: "Midsize"
          market: "Luxury sedans"
        ) {
          ...editorialSegmentFieldsFull
        }
        midsize_wagon: editorialVehicleRankings(edmundsTypeCategory: "Wagon", subsegment: "Midsize", market: "") {
          ...editorialSegmentFieldsFull
        }
        midsize_crossovers: editorialVehicleRankings(
          edmundsTypeCategory: "SUV"
          subsegment: "Midsize"
          market: "SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        midsize_luxury_crossovers: editorialVehicleRankings(
          edmundsTypeCategory: "SUV"
          subsegment: "Midsize"
          market: "Luxury SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.MUSCLE]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
        muscle_coupes: editorialVehicleRankings(edmundsTypeCategory: "Coupe", subsegment: "Muscle car") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.CROSSOVER]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
        x_small_suv: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "X-Small") {
          ...editorialSegmentFieldsFull
        }
        small_suv: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Small") {
          ...editorialSegmentFieldsFull
        }
        midsize_suv: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize") {
          ...editorialSegmentFieldsFull
        }
        midsize_3row_suv: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize 3-row") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.SPORTS_CAR]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
        standard_coupes: editorialVehicleRankings(
          edmundsTypeCategory: "Coupe"
          subsegment: "Standard"
          market: "Coupes"
        ) {
          ...editorialSegmentFieldsFull
        }
        luxury_sport_coupes: editorialVehicleRankings(
          edmundsTypeCategory: "Coupe"
          subsegment: "Sport"
          market: "Luxury coupes"
        ) {
          ...editorialSegmentFieldsFull
        }
        exotic_sport_coupes: editorialVehicleRankings(
          edmundsTypeCategory: "Coupe"
          subsegment: "Sport"
          market: "Exotic coupes"
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.COMPACT]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($pageSize: Int, $isElectric: Boolean!, $rankRangeStart: Int, $rankRangeEnd: Int) {
        compact_sedans: editorialVehicleRankings(edmundsTypeCategory: "Sedan", subsegment: "Small", market: "Sedans") {
          ...editorialSegmentFieldsFull
        }
        compact_hatchbacks: editorialVehicleRankings(
          edmundsTypeCategory: "Hatchback"
          subsegment: "Small"
          market: "Performance hatchbacks"
        ) {
          ...editorialSegmentFieldsFull
        }
        compact_wagons: editorialVehicleRankings(edmundsTypeCategory: "Wagon", subsegment: "Small", market: "") {
          ...editorialSegmentFieldsFull
        }
        compact_crossovers: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Small", market: "SUVs") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.ELECTRICAWD]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        awdElectricCars: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          subsegment: "All-wheel-drive electric cars"
        ) {
          ...editorialSegmentFieldsFull
        }
        awdElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          subsegment: "All-wheel-drive electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        electricCars: editorialVehicleRankings(edmundsTypeCategory: "Electric", subsegment: "Electric cars") {
          ...editorialSegmentFieldsFull
        }
        electricSUVs: editorialVehicleRankings(edmundsTypeCategory: "Electric", subsegment: "Electric SUVs") {
          ...editorialSegmentFieldsFull
        }
        smallElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Electric"
          subsegment: "Small electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        midsizeElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Electric"
          subsegment: "Midsize electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        largeElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Electric"
          subsegment: "Large electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        awdElectricTrucks: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          subsegment: "All-wheel-drive electric trucks"
        ) {
          ...editorialSegmentFieldsFull
        }
        electricTrucks: editorialVehicleRankings(edmundsTypeCategory: "Electric", subsegment: "Electric trucks") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.ELECTRICSUVS]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        electricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Electric"
          subsegment: "Electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        smallElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Electric"
          subsegment: "Small electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        midsizeElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Electric"
          subsegment: "Midsize electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        largeElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Electric"
          subsegment: "Large electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        allWheelDriveElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          subsegment: "All-wheel-drive electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        luxuryElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Luxury electric"
          subsegment: "Electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        smallLuxuryElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Luxury electric"
          subsegment: "Small electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        midsizeLuxuryElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Luxury electric"
          subsegment: "Midsize electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        largeLuxuryElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Luxury electric"
          subsegment: "Large electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        performanceElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Performance electric"
          subsegment: "Electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.HYBRIDSUVS]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        hybridSUVs: editorialVehicleRankings(edmundsTypeCategory: "Hybrid", subsegment: "Hybrid SUVs") {
          ...editorialSegmentFieldsFull
        }
        smallHybridSUVs: editorialVehicleRankings(edmundsTypeCategory: "Hybrid", subsegment: "Small hybrid SUVs") {
          ...editorialSegmentFieldsFull
        }
        midsizeHybridSUVs: editorialVehicleRankings(edmundsTypeCategory: "Hybrid", subsegment: "Midsize hybrid SUVs") {
          ...editorialSegmentFieldsFull
        }
        largeHybridSUVs: editorialVehicleRankings(edmundsTypeCategory: "Hybrid", subsegment: "Large hybrid SUVs") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        pluginHybridSUVs: editorialVehicleRankings(edmundsTypeCategory: "Hybrid", subsegment: "Plug-in hybrid SUVs") {
          ...editorialSegmentFieldsFull
        }
        smallPluginHybridSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Hybrid"
          subsegment: "Small plug-in hybrid SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        midsizePluginHybridSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Hybrid"
          subsegment: "Midsize plug-in hybrid SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        largePluginHybridSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Hybrid"
          subsegment: "Large plug-in hybrid SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.LARGESUVS]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        largeSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Large") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.SMALLSUVS]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        xSmallSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "X-Small") {
          ...editorialSegmentFieldsFull
        }
        smallSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Small") {
          ...editorialSegmentFieldsFull
        }
        small3RowSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Small 3-row") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.MIDSIZESUVS]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        midsizeSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize") {
          ...editorialSegmentFieldsFull
        }
        midsize3RowSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize 3-row") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.LUXURYSUVS]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        luxuryAllWheelDriveElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Luxury electric"
          subsegment: "All-wheel-drive electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        performanceElectricSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Performance electric"
          subsegment: "Electric SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        luxuryPlugInHybridSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Hybrid"
          market: "Luxury hybrids"
          subsegment: "Plug-in hybrid SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        smallLuxuryPlugInHybridSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Hybrid"
          market: "Luxury hybrids"
          subsegment: "Small plug-in hybrid SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
      }
    `,
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        midsizeLuxuryPlugInHybridSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Hybrid"
          market: "Luxury hybrids"
          subsegment: "Midsize plug-in hybrid SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        largeLuxuryPlugInHybridSUVs: editorialVehicleRankings(
          edmundsTypeCategory: "Hybrid"
          market: "Luxury hybrids"
          subsegment: "Large plug-in hybrid SUVs"
        ) {
          ...editorialSegmentFieldsFull
        }
        luxurySUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", market: "Luxury SUVs") {
          ...editorialSegmentFieldsFull
        }
        performanceSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", market: "Performance SUVs") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.LUXURY]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        luxurySedans: editorialVehicleRankings(edmundsTypeCategory: "Sedan", market: "Luxury sedans") {
          ...editorialSegmentFieldsFull
        }
        luxuryCoupes: editorialVehicleRankings(edmundsTypeCategory: "Coupe", market: "Luxury coupes") {
          ...editorialSegmentFieldsFull
        }
        luxurySUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", market: "Luxury SUVs") {
          ...editorialSegmentFieldsFull
        }
        luxuryHybrids: editorialVehicleRankings(edmundsTypeCategory: "Hybrid", market: "Luxury hybrids") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        luxuryConvertibles: editorialVehicleRankings(
          edmundsTypeCategory: "Convertible"
          market: "Luxury convertibles"
        ) {
          ...editorialSegmentFieldsFull
        }
        superLuxuryElectric: editorialVehicleRankings(
          edmundsTypeCategory: "Electric"
          market: "Super Luxury electric"
        ) {
          ...editorialSegmentFieldsFull
        }
        luxuryElectric: editorialVehicleRankings(edmundsTypeCategory: "Electric", market: "Luxury electric") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
  [CAR_TYPES.THREEROWSUVS]: [
    gql`
      ${GRAPHQL_FRAGMENTS.rangeFields}
      ${GRAPHQL_FRAGMENTS.editorialSegmentFieldsFull}
      query ($rankRangeStart: Int, $rankRangeEnd: Int, $pageSize: Int, $isElectric: Boolean!) {
        small3RowSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Small 3-row") {
          ...editorialSegmentFieldsFull
        }
        midsize3RowSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Midsize 3-row") {
          ...editorialSegmentFieldsFull
        }
        largeSUVs: editorialVehicleRankings(edmundsTypeCategory: "SUV", subsegment: "Large") {
          ...editorialSegmentFieldsFull
        }
      }
    `,
  ],
};
